import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { HttpCancelService } from './HttpCancel.service';

export const attachCancelInterceptor: HttpInterceptorFn = (req, next) => {
  const cancelService = inject(HttpCancelService);

  return next(req).pipe(
    takeUntil(cancelService.onCancelPending$)
  );
};
